<script lang="ts">
  import Dialog, { Title, Content, Actions } from '@smui/dialog';
  import Button from '@smui/button';
  import Radio from '@smui/radio';
  import FormField from '@smui/form-field';
  import Portal from '../Portal.svelte';

  import type { FileUpload } from '../../firebase/common/feed';

  export let images: FileUpload[];
  let onPick: (image: FileUpload | null) => void;

  export function pick() {
    open = true;
    picked = null;

    return new Promise<FileUpload | null>((resolve) => {
      onPick = resolve;
    });
  }

  let open: boolean = false;
  let picked: FileUpload | null = null;
</script>

<Portal>
  <Dialog bind:open surface$style="width: 850px; max-width: calc(100vw - 32px);">
    <Title>画像を選択</Title>
    <Content class="images-container">
      {#if images.length === 0}
        <p>挿入できる画像がありません。先に画像をアップロードしてください。</p>
      {/if}
      {#each images as image}
        <FormField>
          <Radio value={image} bind:group={picked} />
          <img src={image.previewUrl} alt="" slot="label" />
        </FormField>
      {/each}
    </Content>
    <Actions>
      <Button
        type="button"
        variant="outlined"
        on:click={() => {
          open = false;
          onPick(picked);
        }}
        disabled={picked === null}>選択</Button
      >
      <Button
        type="button"
        variant="outlined"
        on:click={() => {
          open = false;
          onPick(null);
        }}>キャンセル</Button
      >
    </Actions>
  </Dialog>
</Portal>

<style lang="scss">
  img {
    max-width: 100%;
  }

  :global(.images-container) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    grid-gap: 1rem;
  }
</style>
